import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import cs from './locales/cs.json';
import de from './locales/de.json';
import el from './locales/el.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import hu from './locales/hu.json';
import it from './locales/it.json';
import nb from './locales/nb.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import sk from './locales/sk.json';
import { findAvailableLocaleCode } from './available-locales';

const resources = {
  cs: { translation: cs },
  de: { translation: de },
  el: { translation: el },
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  hu: { translation: hu },
  it: { translation: it },
  nb: { translation: nb },
  nl: { translation: nl },
  pl: { translation: pl },
  pt: { translation: pt },
  sk: { translation: sk },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export function applyLocale(locale: string): void {
  const code = findAvailableLocaleCode(locale);

  if (code !== undefined) {
    void i18n.changeLanguage(code);
  }
}

export default i18n;
